import React, { useEffect, useState, useRef } from 'react';
import { View, Text, StyleSheet, Animated, TouchableOpacity, Linking, Image, ScrollView } from 'react-native';
import { Feather } from '@expo/vector-icons';
import styles from './styles/styles';  // Import the styles
import Sidebar from './sidebar';  // ✅ Import the new Sidebar
import Footer from './footer'; // ✅ Import Footer
import Header from './header'; // ✅ Import Footer


const Service = ({ navigation }) => {

  const [activeLink, setActiveLink] = useState('Service');

  const [showSidebar, setShowSidebar] = useState(false);

  const handleLinkPress = (screen) => {
    setShowSidebar(false); // Close sidebar on navigation
    navigation.navigate(screen);
  };

   const toggleSidebar = () => {
    setShowSidebar(!showSidebar);
  };

    // Example of partners data (add your own partner details here)
  const partners = [
    { name: "Confluent", image: require('./assets/confluent.jpg') },
    { name: "MuleSoft", image: require('./assets/mulesoft.png') },
    { name: "Workato", image: require('./assets/workato.png') },
    { name: "Boomi", image: require('./assets/boomi.webp') },
  ];

  const [visibleIndex, setVisibleIndex] = useState(0);
  const opacities = useRef(partners.map(() => new Animated.Value(0))).current;


  useEffect(() => {
  let currentIndex = 0;

  const animate = (nextIndex, prevIndex) => {
    // Fade out previous
    Animated.timing(opacities[prevIndex], {
      toValue: 0,
      duration: 500,
      useNativeDriver: true,
    }).start();

    // Fade in next
    Animated.timing(opacities[nextIndex], {
      toValue: 1,
      duration: 500,
      useNativeDriver: true,
    }).start();
  };

  // Initial fade-in for first image
  Animated.timing(opacities[0], {
    toValue: 1,
    duration: 500,
    useNativeDriver: true,
  }).start();

  const interval = setInterval(() => {
    const nextIndex = (currentIndex + 1) % partners.length;
    animate(nextIndex, currentIndex);
    currentIndex = nextIndex; // manually update
  }, 3000); // change every 3s

  return () => clearInterval(interval);
}, []);


  return (
    <View style={styles.pageContainer}>

         {/* Fixed Header */}
      <View style={styles.fixedHeader}>
         <Header onToggleSidebar={toggleSidebar} />
      </View>

      {showSidebar && (
        <Sidebar
          activeLink={activeLink}
          handleLinkPress={handleLinkPress}
          onClose={() => setShowSidebar(false)}
        />
      )}


      {/* Scrollable Content */}
     <ScrollView contentContainerStyle={styles.scrollContainer}>

      {/* Main Content */}
      <View style={styles.mainContent}>
        <Text style={styles.heading}>AI-Powered Integration Solutions</Text>


        <View style={{ height: 20 }} /> 
      
       <View style={styles.imageWrapper1}>
        <Image
          source={require('./assets/integration.png')}
          style={styles.storyImage}
          resizeMode="cover"
        />
      </View>

       {/* Plain Paragraphs */}
      <View style={styles.paragraphContainer}>

        <Text style={styles.paragraph}>
          Build and scale integrations with industry-leading tools and models. We use open-source and serverless technologies to deliver cost-effective, on-demand solutions, so you pay only for what you use—without the need for expensive brokers.
        </Text>

      </View>
      
            {/* Three Service Sections */}
      <View style={[styles.horizontalContainer, { justifyContent: 'center' }]}>
        {/* Strategic Consulting */}
        <View style={styles.serviceCard}>
         <View style={styles.cardRow}>
         <Image source={require('./assets/strategic.jpg')} style={styles.serviceIcon} />
          <Text style={styles.serviceTitle}>Strategic Consulting</Text>
         </View>
          <Text style={styles.serviceText}>
            Evaluate your integration maturity, uncover value opportunities driven by APIs
          </Text>
        </View>

        {/* Customer Success */}
        <View style={styles.serviceCard}>
        <View style={styles.cardRow}>
         <Image source={require('./assets/customersuccess.jpg')} style={styles.serviceIcon} />
          <Text style={styles.serviceTitle}>Customer Success</Text>
        </View>
          <Text style={styles.serviceText}>
            Expedite your adoption timelines and adopting best practices
          </Text>
        </View>

        {/* Professional Services */}
        <View style={styles.serviceCard}>
        <View style={styles.cardRow}>
         <Image source={require('./assets/professional.jpg')} style={styles.serviceIcon} />
          <Text style={styles.serviceTitle}>Professional Services</Text>
        </View>
          <Text style={styles.serviceText}>
            Accelerate with IntegrationX's integration expertise to achieve your integration goals
          </Text>
        </View>
      </View>




     
      
       <View style={{ height: 20 }} /> 

       <Text style={styles.heading}>AI-Enabled Automation Solutions</Text>


        <View style={{ height: 20 }} /> 
      
       <View style={styles.imageWrapper}>
        <Image
          source={require('./assets/automation.jpg')}
          style={styles.storyImage}
          resizeMode="cover"
        />
      </View>


       {/* Plain Paragraphs */}
      <View style={styles.paragraphContainer}>
        <Text style={styles.paragraph}>
          Empower employees and automate workflows securely with autonomous, scalable, and resilient integration solutions, maximizing efficiency, insight, and control while minimizing human intervention.
        </Text>
      </View>

     

      <View style={styles.partnersSection}>
        <Text style={styles.heading}>System Integrator Partners</Text>
        <View style={styles.partnerStack}>
          {partners.map((partner, index) => (
            <Animated.View
              key={index}
              style={[
                styles.partnerCard,
                { opacity: opacities[index], position: 'absolute' },
              ]}
            >
              <Image source={partner.image} style={styles.partnerImage} />
            </Animated.View>
          ))}
        </View>
      </View>



        {/* Footer */}
        <Footer navigation={navigation} />

      </View>
      </ScrollView>
    </View>
  );
};

export default Service;
